import { ChakraStylesConfig } from "chakra-react-select/dist/types/types";
import { mergeWith } from "lodash-es";
import { chakraSelectStyles } from "shared/components/input/select/SelectStyles";
import { SelectOptionData } from "shared/components/input/select/SelectTypes";
import { maybernCellErrorClass } from "shared/components/table/maybern/MaybernTableConstants";

export const chakraSimpleSelectStyles: ChakraStylesConfig<SelectOptionData> = {
  ...chakraSelectStyles,
  container: (provided, state) =>
    mergeWith({}, chakraSelectStyles.container?.(provided, state), {
      width: "100%",
      "&:has(.react-select__input:focus-visible:not([data-hidden]))": {
        ".select__search-placeholder": {
          visibility: "visible",
        },
        ".react-select__placeholder": {
          visibility: "hidden",
        },
      },
    }),
  control: (provided, state) =>
    mergeWith({}, chakraSelectStyles.control?.(provided, state), {
      p: 0,
      bg: "white",
    }),
  inputContainer: (provided, state) =>
    mergeWith({}, chakraSelectStyles.inputContainer?.(provided, state), {
      mt: 0,
    }),
  singleValue: (provided, state) =>
    mergeWith({}, chakraSelectStyles.singleValue?.(provided, state), {
      mt: 0,
    }),
  multiValue: (provided, state) =>
    mergeWith({}, chakraSelectStyles.multiValue?.(provided, state), {
      mt: 0,
    }),
  placeholder: (provided, state) =>
    mergeWith({}, chakraSelectStyles.placeholder?.(provided, state), {
      mt: 0,
      visibility: "visible",
      [`.ag-cell.${maybernCellErrorClass} &`]: {
        color: "red.400",
      },
    }),
};
